import { DatePicker, Form } from "antd";
import {
	MESSAGE_VALIDATION,
	validateEndDateAfterStartDate,
} from "common/common";
import dayjs from "dayjs";

const defaultPropsFormItemDatePicker = {
	getValueFromEvent: (value) => value?.format("YYYY-MM-DD HH:mm"),
	getValueProps: (value) => ({
		value: value ? dayjs(value) : undefined,
	}),
	className: "w-full",
};

const defaultPropsDatePicker = {
	className: "w-full [&_.ant-picker-input>input]:text-center",
	allowClear: true,
	showTime: { format: "HH:mm" },
	format: "YYYY-MM-DD HH:mm",
};

const DateRangePicker = ({ label, rules, form }) => {
	const handleChangeFromDate = (value) => {
		if (!value) {
			form.setFieldValue("toDate", null);
			form.validateFields(["toDate"]);
			return;
		}

		if (form.getFieldValue("toDate")) {
			form.validateFields(["toDate"]);
		}
	};

	const fromDate = Form.useWatch("fromDate", form);

	return (
		<div className="col-span-2 flex gap-x-8 relative">
			<Form.Item
				rules={rules}
				label={label}
				name="fromDate"
				{...defaultPropsFormItemDatePicker}
				className="w-[480px] md:w-[430px] relative after:content-['～'] after:absolute after:right-[-22px] after:top-1/2 after:-translate-y-1/2 after:text-gray-400"
			>
				<DatePicker
					placeholder=""
					{...defaultPropsDatePicker}
					onChange={handleChangeFromDate}
				/>
			</Form.Item>

			<Form.Item
				rules={[
					({ getFieldValue }) =>
						validateEndDateAfterStartDate({
							getFieldValue,
							fieldName: "fromDate",
							errorMsgRequired: "イベント期間は必須項目です",
							errorMsgInvalidRange:
								MESSAGE_VALIDATION.END_DATE_MUST_BE_AFTER_START_DATE,
						}),
				]}
				name="toDate"
				{...defaultPropsFormItemDatePicker}
				className="w-[200px] md:w-[230px]"
			>
				<DatePicker
					placeholder=""
					{...defaultPropsDatePicker}
					disabled={!fromDate}
				/>
			</Form.Item>
		</div>
	);
};

export default DateRangePicker;
